import { jsx, jsxs } from "react/jsx-runtime";
import isNumber from "lodash/isNumber";
import { getRangeAngles } from "@teselagen/range-utils";
import PositionAnnotationOnCircle from "./PositionAnnotationOnCircle";
import React from "react";
import draggableClassnames from "../constants/draggableClassnames";
import { pureNoFunc } from "@teselagen/ui";
import { getSelectionMessage } from "../utils/editorUtils";
function Caret({
  caretPosition,
  sequenceLength,
  className,
  onClick,
  isSelection,
  innerRadius,
  outerRadius,
  isProtein,
  selectionMessage,
  showAminoAcidUnitAsCodon
}) {
  const { startAngle, endAngle } = getRangeAngles(
    { start: caretPosition, end: caretPosition },
    sequenceLength || 1
  );
  if (!isNumber(startAngle)) {
    console.error("we've got a problem!");
  }
  const { transform } = PositionAnnotationOnCircle({
    sAngle: startAngle,
    eAngle: endAngle,
    height: 0
  });
  return /* @__PURE__ */ jsxs(
    "g",
    {
      onClick,
      transform,
      className: className + " veCaret " + draggableClassnames.caret,
      children: [
        /* @__PURE__ */ jsx("title", { children: selectionMessage || getSelectionMessage({
          caretPosition,
          isProtein,
          sequenceLength,
          showAminoAcidUnitAsCodon
        }) }),
        /* @__PURE__ */ jsx(
          "line",
          {
            strokeWidth: "1.5px",
            x1: 0,
            y1: -innerRadius,
            x2: 0,
            y2: -outerRadius
          }
        ),
        isSelection ? /* @__PURE__ */ jsx(
          "polygon",
          {
            className: "vePolygonCaretHandle",
            fill: "black",
            points: `0,${-outerRadius + 2} 5,${-outerRadius - 10} -5,${-outerRadius - 10}`
          }
        ) : null
      ]
    },
    caretPosition
  );
}
export default pureNoFunc(Caret);
